'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { getToken, getDeviceId } from '@shared/utils/auth/device';
import { useApi } from '@utils/useApi';
import { useAuth } from '@hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { storage } from '@shared/utils/platform';

const DEVICE_ID_KEY = 'device_id';

export default function LoginPage() {
    const router = useRouter();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const { setUser } = useAuth();
    const { t } = useTranslation();
    const { request } = useApi<any>();

    useEffect(() => {
        checkToken();
    }, []);

    const checkToken = async () => {
        const token = await getToken();
        if (token) {
            try {
                request('get', '/api/Auth/verify', {}, {
                    onSuccess: async (data) => {
                        router.replace('/Home');
                    },
                    onError: () => {
                        localStorage.removeItem("token");
                    }
                });
            } catch {
                localStorage.removeItem("token");
            }
        } else {
            router.replace('/Login');
        }
    };

    const doLogin = async (
        info: { uid: string, loginType: number, name: string, photo: string }
    ) => {
        try {
            const { uid, loginType, name, photo } = info;
            const deviceId = await getDeviceId();

            setUser({
                id: -1,
                uid,
                name,
                photo,
                friendID: '',
                loginType,
                totalBalance: 0,
                diamond: 0,
                isVIP: false,
                gameCount: 0,
                tradeCount: 0,
                tradeWinCount: 0,
                totalProfitLoss: 0,
                winRate: 0,
                isForeverVIP: false
            });

            request('post', '/api/Auth/login', {
                uid,
                type: loginType,
                name,
                photoUrl: photo,
                deviceId
            }, {
                auth: false, //登入不帶token
                onSuccess: async (data) => {
                    // ✅ 成功：儲存 token 並導頁
                    await storage.setItem('token', data.token);

                    // 取得 FCM Token 並上傳
                    // const fcmToken = await getFCMToken();
                    // if (fcmToken) {
                    //     await request('post', '/api/user/save-device-token', {
                    //         deviceToken: fcmToken,
                    //         deviceType: Platform.OS, // 'android' 或 'ios'
                    //     }, { auth: true });
                    // }

                    router.replace('Home');
                }
            });
        } catch (error: any) {
            console.error('登入錯誤:', error);
            alert(t('common.unknownError'));
        }
    };

    return (
        <main style={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', background: '#f5f5f5' }}>
            <div style={{
                width: 360, background: '#fff', borderRadius: 16, padding: 24,
                boxShadow: '0 10px 30px rgba(0,0,0,.08)'
            }}>
            </div>
        </main>
    );
}
